<template>
  <WsUpdate
    ref="wsUpdate"
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :titleKey="'last_version.name'"
    editType="updateVersion"
    @input="$_getModelVersionData($event)"
    :customBreads="$_customBreads()"
  >
  </WsUpdate>
</template>

<script>
import parentmodel from "@/models/act";
import model from "@/models/article";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄目前編輯內容嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data: () => ({
    modelName: model.modelName,
    parentModelName: parentmodel.modelName,
    parentVersionName: parentmodel.versionModelName,
    parentLabel: parentmodel.label,
    label: model.label,
    fields: model.fields.last_version.fields,
    modelVersionData: null,
    parentModelData: null,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "法條內容",
              fields: [
                "no_number",
                "announce_at",
                "effect_at",
                "attaches",
                "reference_link",
                "effects",
                "is_active",
                "act_status",
                "locales",
              ],
            },
          ],
        },
      ],
    },
  }),
  methods: {
    $_getModelVersionData($event) {
      this.modelVersionData = $event;
    },
    async $_getParentModelData() {
      try {
        const res = await this.$axios.get(
          `${this.modelName}/${this.$route.params.id}`
        );
        try {
          const parentRes = await this.$axios.get(
            `${this.parentVersionName}/${
              res.data.data[this.parentVersionName].id
            }`
          );
          this.parentModelData = parentRes.data.data;
        } catch (err) {
          alert(err);
        }
      } catch (err) {
        alert(err);
      }
    },
    $_customBreads() {
      let breadArr = [];
      breadArr.push({
        text: this.parentLabel,
        to: `/${this.parentModelName}`,
        disabled: false,
      });
      if (this.parentModelData) {
        breadArr.push({
          text: this.parentModelData.name,
          to: `/${this.parentModelName}/${this.parentModelData.id}`,
          disabled: false,
        });
      } else {
        breadArr.push({
          text: this.parentLabel,
          to: `/${this.parentModelName}`,
          disabled: false,
        });
      }
      if (this.modelVersionData) {
        const locale = this.$store.state.locale.selectingLocale;
        const noText = this.modelVersionData.locales[locale].no_text;
        breadArr.push({
          text: `${noText} 版本列表`,
          to: `/${this.modelName}/${this.$route.params.id}/version`,
          disabled: false,
        });
      } else {
        breadArr.push({
          text: `版本列表`,
          to: `/${this.parentModelName}`,
          disabled: false,
        });
      }
      breadArr.push({
        text: `編輯歷史版本`,
        disabled: true,
      });

      return breadArr;
    },
  },
  mounted() {
    this.$_getParentModelData();
  },
};
</script>